export default __webpack_public_path__ + "static/media/blue-logo.e80693f5.png";